import NextLink from 'next/link';
import React, { type PropsWithChildren } from 'react';
import type { LinkProps, WebViewLinkProps } from './link.types';
import { cn } from '../../utils/cn';

import styles from './link.module.css';

export const Link: React.FC<WebViewLinkProps & LinkProps & PropsWithChildren> = ({
    children,
    title,
    target,
    className,
    passHref,
    webViewNavigation,
    webViewData,
    showIf = true,
    ...props
}) => {
    const { href, onClick } = props;

    if (!showIf) {
        return null;
    }

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (webViewNavigation && globalThis?.window?.ReactNativeWebView) {
            e.preventDefault();
            globalThis?.window?.ReactNativeWebView?.postMessage?.(webViewData ?? 'no-webview-data');
            return;
        }
        onClick?.(e);
    };

    if (!href) {
        return <>{children}</>;
    }

    return (
        <NextLink
            {...props}
            className={cn(styles.container, className)}
            title={title}
            target={target}
            passHref={passHref}
            onClick={handleClick}
        >
            {children}
        </NextLink>
    );
};
